import React from 'react';
import { Link } from 'react-router-dom';
import { Lightning, EnvelopeSimple } from '@phosphor-icons/react';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-background text-foreground p-6">
      <div className="max-w-3xl mx-auto pt-12 text-center">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <Lightning size={22} weight="fill" className="text-foreground" />
          <span className="font-heading text-lg font-bold text-foreground">Mayr Lead Creator</span>
        </Link>
        <h1 className="font-heading text-3xl font-bold text-foreground mb-4">Get in touch</h1>
        <p className="text-muted-foreground text-sm mb-8 max-w-md mx-auto">Have questions about Mayr Lead Creator? Want a demo? Reach out to our team.</p>
        <div className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-border bg-muted/30">
          <EnvelopeSimple size={20} className="text-foreground" />
          <a href="mailto:hello@mayr-technologies.com" className="text-foreground font-medium">hello@mayr-technologies.com</a>
        </div>
        <p className="text-xs text-muted-foreground mt-6">We typically respond within 24 hours.</p>
        <Link to="/" className="text-sm text-muted-foreground hover:text-foreground underline mt-8 block">Back to home</Link>
      </div>
    </div>
  );
}
